{
  "property_type": "మీరు అపార్ట్‌మెంట్, విల్లా లేదా ఇండిపెండెంట్ హౌస్ కోసం చూస్తున్నారా?",
  "city": "మీకు ఏ నగరం ఆసక్తి?",
  "city_or_locality": "మీరు ఏ నగరం లేదా ప్రాంతంలో చూస్తున్నారు?",
  "bedrooms": "మీకు ఎన్ని బెడ్‌రూమ్‌లు (BHK) కావాలి?",
  "carpet_area": "మీకు ఎంత చదరపు విస్తీర్ణం (చ.అ.) కావాలి?",
  "plot_size": "మీకు ఎంత ప్లాట్ పరిమాణం కావాలి?",
  "budget": "మీ బడ్జెట్ ఎంత?",
  "generic": "దయచేసి {{field}} పేర్కొనండి.",
  "_generic_follow_up": "మీరు ఏ రకమైన ఆస్తి కోసం చూస్తున్నారో మరింత వివరాలు ఇవ్వండి."
}
